import api from '@/core/apiclient'
import { actionTypes, mutationTypes } from '@/core/constants'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.ADESAO.BUSCAR_ORGAOS](context, idAta) {
		const { data } = await api.adesao.buscarOrgaosAdesao(idAta)
		return data
	},

	async [actionTypes.ADESAO.BUSCAR_LISTAGEM](context, obj) {
		const { data } = await api.adesao.buscarListagem(obj)
		return data
	},

	async [actionTypes.ADESAO.CRIAR_ADESAO](context, objParam) {
		const { data } = await api.adesao.criarAdesao(objParam)
		return data
	},

	async [actionTypes.ADESAO.BUSCAR_POR_ID](context, idAdesao) {
		const { data } = await api.adesao.buscarAdesaoPorId(idAdesao)
		return data
	},

	async [actionTypes.ADESAO.EDITAR_ADESAO](cotext, objAdesao) {
		const { data } = await api.adesao.editarAdesaoPorId(objAdesao.id, {
			justificativa: objAdesao.justificativa,
			numeroProcesso: objAdesao.numeroProcesso,
			doe: objAdesao.doe,
		})

		return data
	},

	async [actionTypes.ADESAO.BUSCAR_ITENS](context, { paginacao, idAdesao }) {
		const { data } = await api.adesao.buscarItensAdesao(paginacao, idAdesao)
		return data
	},

	async [actionTypes.ADESAO.SALVAR_ITEM_DISPONIVEL_QUANTIDADE](
		{ commit },
		salvarItemDisponivelQuantidadeAdesaoInput,
	) {
		commit(mutationTypes.COMUM.SET_HABILITAR_SALVAMENTO_AUTOMATICO)
		const { data } = await api.adesao.salvarItemDisponivelQuantidade(salvarItemDisponivelQuantidadeAdesaoInput)
		commit(mutationTypes.COMUM.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
		return data
	},

	async [actionTypes.ADESAO.SALVAR_ITENS](context, salvarItensAdesaoInput) {
		const { data } = await api.adesao.salvarItens(salvarItensAdesaoInput)
		return data
	},

	async [actionTypes.ADESAO.EXCLUIR_ITEM](context, removerItensEmRascunhoPedidoInput) {
		const { data } = await api.adesao.excluirItemAdesao(removerItensEmRascunhoPedidoInput)
		return data
	},

	async [actionTypes.ADESAO.EXCLUIR](context, removerAdesaoInput) {
		const { data } = await api.adesao.excluirAdesao(removerAdesaoInput)
		return data
	},

	async [actionTypes.ADESAO.BUSCAR_TIPO_VISUALIZACAO](conetxt, idAdesao) {
		const { data } = await api.adesao.buscarTipoVisualizacao(idAdesao)
		return data
	},

	async [actionTypes.ADESAO.RECUSAR](context, objRecusaAdesao) {
		await api.adesao.recusarAdesao(objRecusaAdesao)
	},
	async [actionTypes.ADESAO.ACEITAR](context, objAceitarAdesao) {
		await api.adesao.aceitarAdesao(objAceitarAdesao)
	},
	async [actionTypes.ADESAO.BUSCAR_QUANTIDADE_FORNECEDORES_ITENS](context, idAdesao) {
		const { data } = await api.adesao.buscarQuantidadeFornecedoresItens(idAdesao)
		return data
	},
	async [actionTypes.ADESAO.BUSCAR_QUANTIDADE_ADESOES](context) {
		const { data } = await api.adesao.buscarQuantidadeAdesoes()
		return data
	},

	async [actionTypes.ADESAO.BUSCAR_ADESOES_POR_ATA](context, objFiltro) {
		const { data } = await api.adesao.buscarAdesoesPorAta(objFiltro)

		return data
	},
	async [actionTypes.ADESAO.CONCLUIR](context, { idAdesao }) {
		await api.adesao.concluirAdesao(idAdesao)
	},
	async [actionTypes.ADESAO.POSSUI_ITENS_PENDENTES](context, { idAdesao }) {
		const { data } = await api.adesao.possuiItensPendentes(idAdesao)
		return data
	},
	async [actionTypes.ADESAO.BPM.BUSCAR_EXTENSIONS_TASKS](context, params) {
		const { data } = await api.adesaoBpmApiClient.buscarExtensionsTask(params)
		return data
	},
	async [actionTypes.ADESAO.INTEGRACAO.ENVIAR](context, idAdesao) {
		await api.adesao.enviarAdesaoIntegracao(idAdesao)
	},
	async [actionTypes.ADESAO.VISUALIZAR_PROCESSO_DIGITAL](context, idAdesao) {
		const { data } = await api.adesao.visualizarProcessoDigitalAdesao(idAdesao)
		return data
	},
	async [actionTypes.ADESAO.BAIXAR_RELATORIO_PREVIO](context, idAdesao) {
		const response = await api.adesao.baixarRelatorioPrevioAdesao(idAdesao)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.ADESAO.REENVIAR_ADESAO_PARA_DETALHAMENTO](context, idAdesao) {
		await api.adesao.reenviarAdesaoParaDetalhamento(idAdesao)
	},
}
